import {
    VAS_LIST_START,
    VAS_LIST_SUCCESS,
    VAS_LIST_ERROR,
} from "Constant";

const initialState = {
    loading: false,
    data: [],
};
export default function ValueAddedServicesListReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case VAS_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case VAS_LIST_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case VAS_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

